import type {
    ProfilePagePropertyOnboardingContextFieldsV1,
    ProfilePagePropertyOnboardingContextIdsV1,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    AddGovtAuthorityElementPropertyOnboardingManifestV1,
    AddOwnerElementPropertyOnboardingManifestV1,
    CompanyAddressElementPropertyOnboardingManifestV1,
    CompanyCountryElementPropertyOnboardingManifestV1,
    CompanyNameElementPropertyOnboardingManifestV1,
    CompanyZipCodeElementPropertyOnboardingManifestV1,
    ConfirmRemoveGovtAuthorityElementPropertyOnboardingManifestV1,
    ConfirmRemoveOwnerElementPropertyOnboardingManifestV1,
    ContactCountryCodeElementPropertyOnboardingManifestV1,
    ContactPhoneNumberElementPropertyOnboardingManifestV1,
    GovtBirthDateElementPropertyOnboardingManifestV1,
    GovtControlToggleElementPropertyOnboardingManifestV1,
    GovtFirstNameElementPropertyOnboardingManifestV1,
    GovtLastNameElementPropertyOnboardingManifestV1,
    GovtNationalityElementPropertyOnboardingManifestV1,
    GovtResidenceInfoAddressElementPropertyOnboardingManifestV1,
    GovtResidenceInfoCountryElementPropertyOnboardingManifestV1,
    GovtResidenceInfoTooltipElementPropertyOnboardingManifestV1,
    GovtResidenceInfoZipCodeElementPropertyOnboardingManifestV1,
    HostBirthDateElementPropertyOnboardingManifestV1,
    HostFirstNameElementPropertyOnboardingManifestV1,
    HostLastNameElementPropertyOnboardingManifestV1,
    HostNationalityElementPropertyOnboardingManifestV1,
    HostResidenceInfoAddressElementPropertyOnboardingManifestV1,
    HostResidenceInfoCityElementPropertyOnboardingManifestV1,
    HostResidenceInfoCountryElementPropertyOnboardingManifestV1,
    HostResidenceInfoStateElementPropertyOnboardingManifestV1,
    HostResidenceInfoTooltipElementPropertyOnboardingManifestV1,
    HostResidenceInfoZipCodeElementPropertyOnboardingManifestV1,
    ListYourPropertyBackElementPropertyOnboardingManifestV1,
    ListYourPropertyNextElementPropertyOnboardingManifestV1,
    ListYourPropertyStepperElementPropertyOnboardingManifestV1,
    OwnerBirthDateElementPropertyOnboardingManifestV1,
    OwnerFirstNameElementPropertyOnboardingManifestV1,
    OwnerLastNameElementPropertyOnboardingManifestV1,
    OwnerNationalityElementPropertyOnboardingManifestV1,
    OwnerResidenceInfoAddressElementPropertyOnboardingManifestV1,
    OwnerResidenceInfoCountryElementPropertyOnboardingManifestV1,
    OwnerResidenceInfoTooltipElementPropertyOnboardingManifestV1,
    OwnerResidenceInfoZipCodeElementPropertyOnboardingManifestV1,
    PreferredLanguageElementPropertyOnboardingManifestV1,
    PrivateHostElementPropertyOnboardingManifestV1,
    ProfessionalHostElementPropertyOnboardingManifestV1,
    RemoveGovtAuthorityElementPropertyOnboardingManifestV1,
    RemoveOwnerElementPropertyOnboardingManifestV1,
    SaveAndExitElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import {
    ProfilePagePropertyOnboardingContextManifestV1,
    WebListYourPropertyProfileVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/profile-page";
import { BaseContextFieldsMapping, GetAttributeSafe } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const profileBinder = defineBinder(({ webAnalytics, action: { click, hover } }) => {
    webAnalytics.pageContext<ProfilePagePropertyOnboardingContextIdsV1, ProfilePagePropertyOnboardingContextFieldsV1>(
        ProfilePagePropertyOnboardingContextManifestV1.ids,
        {
            auth_user_id: BaseContextFieldsMapping.auth_user_id,
            member_id: BaseContextFieldsMapping.member_id,
            property_id: BaseContextFieldsMapping.property_id,
            is_internal_user: BaseContextFieldsMapping.is_internal_user,
        },
    );

    webAnalytics.observe(WebListYourPropertyProfileVisitEventPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], ListYourPropertyNextElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyBackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyStepperElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "step-name"),
    });
    webAnalytics.observeElement([click], SaveAndExitElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], PrivateHostElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ProfessionalHostElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], HostFirstNameElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], HostLastNameElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], HostNationalityElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], HostBirthDateElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, hover], HostResidenceInfoTooltipElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], HostResidenceInfoCountryElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], HostResidenceInfoStateElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], HostResidenceInfoCityElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], HostResidenceInfoAddressElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], HostResidenceInfoZipCodeElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], PreferredLanguageElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ContactCountryCodeElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ContactPhoneNumberElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CompanyNameElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CompanyAddressElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CompanyCountryElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CompanyZipCodeElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], OwnerFirstNameElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], OwnerLastNameElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], OwnerNationalityElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], OwnerBirthDateElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, hover], OwnerResidenceInfoTooltipElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], OwnerResidenceInfoCountryElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], OwnerResidenceInfoAddressElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], OwnerResidenceInfoZipCodeElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], AddOwnerElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], RemoveOwnerElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ConfirmRemoveOwnerElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], GovtControlToggleElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], GovtFirstNameElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], GovtLastNameElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], GovtNationalityElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], GovtBirthDateElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, hover], GovtResidenceInfoTooltipElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], GovtResidenceInfoCountryElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], GovtResidenceInfoAddressElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], GovtResidenceInfoZipCodeElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], AddGovtAuthorityElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], RemoveGovtAuthorityElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ConfirmRemoveGovtAuthorityElementPropertyOnboardingManifestV1.ids, {});
});
